import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslationDomainService } from '@app/translation/domain/translation-domain.service';
import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserHashTranslationResolver implements Resolve<string> {
  constructor(private translationDomainService: TranslationDomainService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<string> {
    const userHash = route.params['hash'];
    return this.translationDomainService.getUserLanguageByHash$(userHash).pipe(
      tap(language => {
        if (language && language !== this.translationDomainService.getActiveLanguage()) {
          this.translationDomainService.setActiveLanguage(language);
        }
      }),
    );
  }
}
